module.exports = __webpack_public_path__ + "static/img/1366-bg.f27aaa3b.png";